import { notification } from 'antd';
import type { ArgsProps } from 'antd/es/notification';

export const openNewTab = (url: string) => {
  if (window) {
    window.open(url);
  }
};

export const openNotification = (
  message: string,
  description: string,
  placement?: ArgsProps['placement'],
  duration?: number,
  type?: string
) => {
  notification[type || 'info']({
    message,
    description,
    duration: duration || 2.0,
    placement: placement || 'top',
  });
};
